.uxn-notification-bell {
	min-width: var(--uxn-notification-bell-min-width);
	min-height: var(--uxn-notification-bell-min-height);
	background: var(--uxn-notification-bell-background);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	position: relative;
	white-space: nowrap;

	.debug {
		position: absolute;
		top: 0;
		right: 100px;
		width: 200px;
		height: 200px;
		border: 5px solid black;
		background: white;
		white-space: nowrap;
	}

	.ux-iws-navigation-meta__item & {
		margin-right: 5px;
	}

	.uxn-notification-bell__content {
		position: relative;
	}

	&:hover {
		background: var(--uxn-notification-bell-background-hover);
	}

	.ux-notification-bell {
		div[slot="notifications-bell"] & {
			background: none;
		}
	}
}

a[data-name="notifications"] {
	cursor: pointer;

	span {
		cursor: pointer;
	}
}
